export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5021.d0add951.jpg";